<template>
  <div class="jobTopDiv">
      <div style="width:100%;background:white;height:93px;">
        <div class="content">
            <el-row class="search">
                <el-input  placeholder="请输入公司关键字" v-model="searchWord" class="myInput search-input input-with-select">
                    <!-- <el-select style="width:100px" v-model="select" slot="prepend" placeholder="北京">
                    </el-select> -->
                    <span slot="prepend" style="cursor:pointer" @click="isCityShow = true">
                        <span style="margin-right:9px;font-size:14px">{{select}}</span>
                        <span class="iconfont">&#xe612;</span>
                    </span>
                    <!-- <span class="slot" slot="suffix">
                        <img class="micrphone" title="长按录音语音识别" @mousedown="startRecord" @mouseup="stopRecord" src="../assets/pcImage/icon/icon_micrphone.png" alt />
                    </span> -->
                    <el-button class="btnSearch" slot="append" @click="searchCompanies">搜索</el-button>
                </el-input>
            </el-row>
        </div>
    </div>
    <div class="middleDiv">
        <div class="contentSearchWord">
            <el-row class="topMenu">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="breadBody">
                    <el-breadcrumb-item v-if="this.$store.state.chinadata.selectedAreas.length <= 0" class="bread">全国</el-breadcrumb-item>
                    <el-breadcrumb-item @click.native="breadcrumbClick(item)" v-for="item in this.$store.state.chinadata.selectedAreas" class="bread" >{{item.name}}</el-breadcrumb-item>
                </el-breadcrumb>
                <ul class="area">
                    <li style="padding-left:0px;">热门城市:</li>
                    <li :class="$store.state.chinadata.initActive == -1 ? 'isActive' : ''" @click="selectDepCity({name:'全国'},-1)">全国</li>
                    <li :class="$store.state.chinadata.initActive == index ? 'isActive' : ''" v-for="(item,index) in this.$store.state.chinadata.hotCitys" 
                        @click="selectDepCity(item,index)">{{item.name}}</li>
                </ul>
                <div class="cityComp">
                    <CityComp @selectCity="selectCityHandler"/>
                </div>
            </el-row>
            <!-- 动态获取城市数据，循环此块即可，控制每行显示数量 -->
            <el-row :span="24">
                <el-col class="sub" v-if="this.$store.state.chinadata.subAreas.length > 0">
                    <ul class="subMenu">
                        <li @click="selectDepCity({name:'subMenu'},-2)" :class="subActive == -2 ? 'isActive' : ''" style="margin-right:30px">不限</li>
                        <li style="margin-right:30px" :class="subActive == index ? 'isActive' : ''"
                            v-for="(item,index) in this.$store.state.chinadata.subAreas" 
                            @click="selectDepCity(item,index)">{{item.name}}</li>
                    </ul>
                </el-col>
            </el-row>
            <el-row class="topMenu" style="height:80px">
                <el-col :span="1.5" style="line-height:40px;width:85px"><span>行业类型:</span></el-col>
                <el-col :span="14" 
                    <ul class="area">
                        <li :class="catagoryActive == -1 ? 'isActive' : ''" @click="catagoryClick({},-1)">不限</li>
                        <li :class="catagoryActive == index ? 'isActive' : ''" v-for="(item,index) in catagories_arr" 
                            @click="catagoryClick(item,index)">{{item.name}}</li>
                    </ul>
                </el-col>
            </el-row>
            <el-row class="topMenu">
                <el-col :span="1.5" style="line-height:40px"><span>公司规模:</span></el-col>
                <el-col :span="14" 
                    <ul class="area">
                        <li :class="companySize == -1 ? 'isActive' : ''" @click="companySizeClick({},-1)">不限</li>
                        <li :class="companySize == index ? 'isActive' : ''" v-for="(item,index) in peopleNum_arr" 
                            @click="companySizeClick(item,index)">{{item.text}}</li>
                    </ul>
                </el-col>
            </el-row>
            <el-row class="topMenu">
            <el-col :span="1.5"><span>筛选条件:</span></el-col>
            <el-col :span="3" style="margin-left:26px">
                <el-select class="search-input1 null-input input" v-model="value1" placeholder="工作经验" @change="workExperienceChange">
                    <el-option v-for="item in workExperience_arr" :key="item.value" :label="item.text" :value="item.value"></el-option>
                </el-select>
            </el-col>
            <el-col :span="3">
                <el-select class="search-input1 null-input input" v-model="value3" placeholder="学历要求" @change="educationChange">
                    <el-option v-for="item in education_arr" :key="item.value" :label="item.text" :value="item.value"> </el-option>
                </el-select>
            </el-col>
            <el-col :span="3">
                <el-select class="search-input1 null-input input" v-model="value5" placeholder="就业类型" @change="formsOfEmploymentChange">
                    <el-option v-for="item in formsOfEmployment_arr" :key="item.value" :label="item.text" :value="item.value"> </el-option>
                </el-select>
            </el-col>
            <!-- <el-col :span="3">
                <el-select class="search-input1 null-input input" v-model="value6" placeholder="受损等级" @change="damagedLevelChange">
                    <el-option v-for="item in damagedLevel_arr" :key="item.value" :label="item.text" :value="item.value"> </el-option>
                </el-select>
            </el-col> -->
          </el-row>
        </div>
    </div>
    <div class="jobContent">
        <el-row>
            <el-col :span="24">
                <div>
                    <div style="display:flex;jusity-content:flex-start;flex-wrap:wrap;margin-bottom:24px;">
                      <CompanyInfo v-for="(item,index) in companies_arr" :key="index" :item="item" style="margin-right:17px" @click.native="navToJobInfo(item)"/>
                    </div>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        style="text-align:center"
                        :page-size="pageSize"
                        :total="totalSize"
                        :hide-on-single-page="true"
                        :current-page="viewPageNum"
                        @current-change="pageChange"
                        @prev-click="pageChange"
                        @next-click="pageChange">
                    </el-pagination>

                   
                </div>
                <div style="width:800px;height:100px" v-if="companies_arr.length == 0">未找到任何匹配的公司信息！</div>
            </el-col>
        </el-row>
    </div>
    <el-dialog title="选择城市" custom-class="dialogJobs" :visible.sync="isCityShow" top="20vh" left="10vh" show-close width="850px">
        <CityCompNew @selectCity="selectCityHandler"/>
    </el-dialog>
  </div>
</template>
<script>
import CompanyInfo from "@/components/CompanyInfo.vue";
import CityComp from "@/components/CityComp.vue";
import { initDictOptions, filterDictText } from "@/comm/JDictSelectUtil";
import { getAction, postAction, putAction } from "@/comm/manage";
import CityCompNew from "../components/CityCompNew.vue";
import { mapGetters, mapState } from "vuex";
import Vue from "vue";

export default {
  components: {
    CompanyInfo,
    
    CityComp,
    CityCompNew,
  },
  data() {
    return {
      url: {
        list: "/position/tsCompanyPosition/companyList",
      },
      searchParam: {},
      isBackground:true,
      searchWord: "",
      select: "全国",
      spanWidth: 1,
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      pageSize: 9,
      curPage: 0,
      totalSize: 0,
      typeSpanWidth: 1.5,
      isCityShow: false,
      active: -1,
      subActive: -1,
      companies_arr: [],
      education_arr: [],
      formsOfEmployment_arr: [],
      catagoryActive: -1,
      companySize: -1,
      catagories_arr: [],
      viewPageNum: 1,
      peopleNum_arr: [],
      workExperience_arr: [],
      damagedLevel_arr: [],
    };
  },
  created() {
    this.$store.dispatch("setIsShowHead", true);
    this.initDictConfig();
    if (this.$store.state.chinadata.hotCitys.length == 0)
      this.$store.dispatch("loadHotCity");
    this.searchParam.curPage = this.curPage;
    this.searchParam.pageSize = this.pageSize;
    if (this.$store.state.users.currCity.name) {
      this.select = this.$store.state.users.currCity.name;
      this.searchParam.cpProvince = this.$store.state.users.currCity.cid;
    }
    this.searchWord = this.$route.params.searchWord;
    this.loadCompanyLists();
    this.loadCategories();
    if (this.searchWord) {
      this.searchCompanies();
    }
  },
  mounted() {
    
  },
  computed: {
    ...mapState({
      currCity: (state) => state.users.currCity,
    }),
  },
  watch: {
    currCity(next) {
      //   this.select = next.name;
      this.selectCityHandler(next);
    },
  },
  methods: {
    initDictConfig() {
      initDictOptions("workExperience").then((res) => {
        if (res.success) {
          this.workExperience_arr = res.result;
        }
      });
      initDictOptions("selectEducation").then((res) => {
        if (res.success) {
          this.education_arr = res.result;
        }
      });
      initDictOptions("formsOfEmployment").then((res) => {
        if (res.success) {
          this.formsOfEmployment_arr = res.result;
        }
      });
      initDictOptions("damagedLevel").then((res) => {
        if (res.success) {
          this.damagedLevel_arr = res.result;
        }
      });
      initDictOptions("people_num").then((res) => {
        if (res.success) {
          this.peopleNum_arr = res.result;
        }
      });
    },
    loadCompanyLists() {
      getAction(this.url.list, this.searchParam).then((res) => {
        
        if (res.success) {
          this.companies_arr = res.result;
          this.totalSize = res.total;
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
      });
    },
    selectCityHandler(item, index) {
      this.select = item.name;
      this.isCityShow = false;
      this.selectDepCity(item, index);
    },
    loadCategories() {
      let params = { pageSize: 100, pid: 0 };
      getAction("/sys/category/rootList", params).then((res) => {
        if (res.success) {
          this.catagories_arr = res.result.records;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    catagoryClick(item, index) {
      if (index == -1) {
        this.searchParam.comIndustry = null;
      } else {
        this.searchParam.comIndustry = item.name;
      }
      this.catagoryActive = index;
      this.loadCompanyLists();
    },
    companySizeClick(item, index) {
      if (index == -1) {
        this.searchParam.comPersonnelSize = null;
      } else {
        this.searchParam.comPersonnelSize = item.value;
      }
      this.companySize = index;
      this.loadCompanyLists();
    },
    selectDepCity(item, index) {
      this.select = item.name;
      if (item.name == "全国") {
        this.$store.commit("SET_SELECTEDAREAS", []);
        this.$store.commit("SET_SUBAREAS", []);
        this.active = -1;
        // this.isActive = -1;
        this.$store.commit("SET_INITACTIVE", -1);
        this.searchParam.cpProvince = null;
        this.searchParam.cpCity = null;
        this.searchParam.cpCounty = null;
      } else {
        if (index == -2) {
          this.searchParam.cpCity = null;
          this.searchParam.cpCounty = null;
          this.subActive = -2;
        } else {
          let params = {
            pageSize: 1000,
            pid: item.cid,
            name: item.name,
          };
          if (item.cid.length == 4) {
            // this.active = index;
            this.$store.commit("SET_INITACTIVE", index);
            this.subActive = -1;
            this.$store.dispatch("loadSubAreas", params);
            let objSelected = [
              { cid: item.cid, name: item.name },
              { cid: "", name: "不限" },
            ];
            this.$store.commit("SET_SELECTEDAREAS", objSelected);
            this.searchParam.cpProvince = item.cid;
            this.searchParam.cpCity = null;
            this.searchParam.cpCounty = null;
          } else if (item.cid.length == 6) {
            this.$store.dispatch("loadSubAreas", params);
            let objSelected = { cid: item.cid, name: item.name };
            this.$store.commit("SET_MIDDLEAREAS", objSelected);
            this.searchParam.cpCity = item.cid;
            this.searchParam.cpCounty = null;
          } else {
            this.subActive = index;
            let objSelected = { cid: item.cid, name: item.name };
            this.$store.commit("SET_LASTAREAS", objSelected);
            this.searchParam.cpCounty = item.cid;
          }
        }
      }
      this.viewPageNum = 1;
      this.loadCompanyLists();
    },
    breadcrumbClick(e) {
      if (this.getStrLength(e.cid) <= 6) {
        this.$store.state.chinadata.selectedAreas.pop();
        this.selectDepCity(this.$store.state.chinadata.selectedAreas[0], -1);
      }
    },
    getStrLength(val) {
      return val.replace(/[\u0391-\uFFE5]/g, "aa").length; //"g" 表示全局匹配
    },
    workExperienceChange(val) {
      val == "all"
        ? (this.searchParam.cpJobYears = null)
        : (this.searchParam.cpJobYears = val);
      this.loadCompanyLists();
    },
    damagedLevelChange(val) {
      val == "all"
        ? (this.searchParam.cpDamagedLevel = null)
        : (this.searchParam.cpDamagedLevel = val);
      this.loadCompanyLists();
    },
    educationChange(val) {
      val == "all"
        ? (this.searchParam.cpEducation = null)
        : (this.searchParam.cpEducation = val);
      this.loadCompanyLists();
    },
    formsOfEmploymentChange(val) {
      val == "all"
        ? (this.searchParam.cpFormsOfEmployment = null)
        : (this.searchParam.cpFormsOfEmployment = val);
      this.loadCompanyLists();
    },
    levelChange(val) {
      val == "all"
        ? (this.searchParam.cpDays = null)
        : (this.searchParam.cpDays = val);
      this.loadCompanyLists();
    },
    pageChange(val) {
      this.viewPageNum = val;
      this.searchParam.curPage = (val - 1) * this.pageSize;
      this.searchParam.pageSize = this.pageSize;
      console.log(this.searchParam);
      this.loadCompanyLists();
    },
    searchCompanies() {
      // if(this.searchWord == ""){
      //     this.$message.warning("请输入职位名称");
      //     return;
      // }
      this.searchParam.comName = this.searchWord;
      this.loadCompanyLists();
    },
    navToJobInfo(item) {
      // this.$router.push('./pcCompanyInfo');
      // this.$store.commit("SET_CURRENTCOMITEM", item);
      
      const { href } = this.$router.resolve({
        path: `./pcCompanyInfo`,
        query: { id: item.comId },
      });
      window.open(href, "_blank");
    },
    startRecord() {
      this.searchWord = "录音中，请开始讲话...";
      window.recorder.start();
    },
    stopRecord() {
      this.searchWord = "录音完成，识别中...";
      window.recorder.stop();
      setTimeout(() => {
        let blob = window.recorder.getWAVBlob();
        var wavefilefromblob = new File([blob], "recorder.wav", {
          type: "audio/wav",
        });
        var formdata = new FormData();
        formdata.append("sourceType", "1");
        formdata.append("file", wavefilefromblob);
        postAction("/afs/sentence", formdata).then((res) => {
          if (res.success) {
            this.searchWord = res.data.replace("。", "");
            this.searchCompanies();
          }
        });
      }, 200);
    },
  },
};
</script>
<style>
.bread .el-breadcrumb__inner:hover {
  color: #f82b17;
  cursor: pointer;
  font-size: 13px;
}
</style>
<style lang="stylus" scoped>
.isActive {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #F72B17;
  line-height: 20px;
  // margin-right: 14px;
  cursor: pointer;
}

.myInput >>> input:focus {
  outline: none;
}

.search-input input.el-input__inner {
  border: 0px solid #f82b17;
}

.search-input1 input.el-input__inner {
  border: 0px solid #f82b17;
  height: 20px;
  background-color: white;
  color: black;
}

.null-input >>> .el-input__inner {
  // background-color: #7DCBDC;
  color: #333333;
  height: 44px;
  border-radius: 0;
  border-width: 0px;
  font-size: 12px;
  line-height: 44px;
}

.input ::-webkit-input-placeholder {
  color: black;
  font-family: 'SourceHanSansCN';
  font-size: 13px;
}

.input ::-moz-placeholder {
  color: black;
  font-family: 'SourceHanSansCN';
  font-size: 13px;
}

.input ::-ms-input-placeholder {
  color: black;
  font-family: 'SourceHanSansCN';
  font-size: 13px;
}

.mychk .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #f82b17;
}

.input-with-select {
  border: 1px solid #f72b17;

  &:hover {
    border: 1px solid #f72b17;
  }

  border-radius: 6px;
  outline: none;
  font-size: 16px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
}

.micrphone {
  width: 54px;
  height: 54px;
  margin-top: -18px;
  margin-right: 20px;

  &:hover {
    content: url('../assets/pcImage/icon/icon_micrphone_selected.png');
  }
}

.jobTopDiv {
  width: 100%;
  font-size: 13px;
  font-weight: 500;
  background: rgba(250, 250, 250, 1);
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;

  .content {
    width: 1200px;
    margin: 0 auto;

    .search {
      width: 90%;
      padding-top: 25px;

      .btnSearch {
        width: 120px;
        height: 42px;
        background: #f72b17;
        border: none;
        border-radius: 6px;
        color: white;
        font-size: 16px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 16px;
        margin-right: -25px;
        margin-top: -8px;
      }
    }
  }

  .middleDiv {
    width: 100%;
    background-color: white;

    .contentSearchWord {
      width: 1200px;
      margin: 0 auto;
      background-color: white;

      .topMenu {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 45px;
        line-height: 40px;
        border-bottom: 1px solid #F7F7F7;
        background-color: white;
        font-size: 13px;

        .area {
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          padding-left: 0px;
          margin: 0px;
          font-weight: 400px;
          color: rgba(51, 51, 51, 1);

          ul {
            padding: 0;
            list-style: none;
          }

          li {
            // width:50px; height:30px;
            margin-left: 25px;
            display: inline-block;
            text-align: center;
            line-height: 30px;
            cursor: pointer;
          }

          li.checked:before {
            background-color: #0CF;
            border: 1px #fff solid;
          }

          li.checked {
            font-size: 14px;
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: #F72B17;
                  line-height: 20px;
                  margin-right: 14px;
                  cursor: pointer;
          }
        }
      }

      .sub {
        border-bottom: 1px solid #f7f7f7;
        background-color: white;
      }

      .subMenu {
        font-size: 13px;
        text-align: left;
        min-height: 30px;
        margin-top: 0px;
        line-height: 50px;
        padding-left: 0px;

        ul, li {
          padding-left: 30px;
          list-style: none;
          float: left;
          text-align: left;
          padding: 0px;

          &:hover {
            color: #f82b17;
            cursor: pointer;
          }
        }
      }
    }
  }

  .jobContent {
    width: 1200px;
    margin: 0 auto;
    margin-top: 34px;
    padding-bottom: 34px;
  }

  .upload {
    width: 220px;
    height: 44px;
    background: #f82b17;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 20px;
  }

  .rightTop {
    background: white;
    width: 300px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rightBottom {
    margin-top: 16px;
    width: 300px;
    height: 380px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    text-align: left;
    padding: 16px;

    .hotJob {
      border-bottom: 1px solid rgb(245, 245, 245);
      padding-bottom: 16px;
      font-size: 16px;
      font-weight: 500;
      color: #f82b17;
      line-height: 24px;
    }

    .jobInfo {
      border-bottom: 1px solid rgb(245, 245, 245);
      cursor: pointer;

      .jobTitle {
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
      }

      .money {
        font-size: 14px;
        font-weight: 400;
        color: rgba(242, 20, 47, 1);
        line-height: 21px;
        text-align: right;
      }

      .company {
        font-size: 12px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 18px;
        color: #c2c2c2;
        margin-bottom: 15px;
      }
    }
  }

  .breadBody {
    font-size: 13px;
  }

  .cityComp {
    position: absolute;
    top: 0;
    right: 0;
    margin-left: 25px;
  }
}
</style>